module.exports = __webpack_public_path__ + "img/selected3-min.b116f454.png";